.chatMessage {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 10px 16px;
    margin: 12px;
    border-radius: 8px;
    max-width: 100%;
    animation: fadeIn 0.3s ease;

    &:first-child {
        margin-top: 0;
    }

    &__assistant {
        background: #fff;
    }

    &__user {
        background: #f1f2f6;
    }

    &__avatar {
        flex-shrink: 0;
        color: white;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 4px;
    }

    &__content {
        border-radius: 16px;
        padding: 10px 0;
        font-size: 16px;
        line-height: 1.5;
        color: #1a1a1a;
        justify-content: space-between;
        // box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
        word-break: break-word;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        min-width: calc(100% - 48px);

        &__user {
            display: flex;
            font-size: 18px;
        }

        // &:hover {
        //     transform: translateY(-1px);
        //     box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
        // }
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(6px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}